import React from 'react';

export default function MealSlotViewModeToggle({ viewMode, onToggle, className = '' }) {
  return (
    <button
      type="button"
      onClick={onToggle}
      className={`px-2.5 py-1.5 rounded-md bg-gray-100 text-gray-700 hover:bg-gray-200 text-sm font-medium w-fit focus:outline-none focus:ring-0 ${className}`.trim()}
      title={viewMode === 'options-first' ? 'Show by meal type' : 'Show by option'}
    >
      {viewMode === 'options-first' ? 'By meal type' : 'By option'}
    </button>
  );
}
